<template>
  <div class="ui-center bloco-cadastro" v-bind:class="{ blococadastrosenha: isActive }" id="bloco">
    <div class="bloco" id="user_detail1" v-if="activePhase == 'email'">
      <h1 class="ui-title f-32 cadastro_title">Seja bem-vindo!</h1>
      <h4 class="ui-paragraph f-20 cadastro_frase" :class="fonte_invalida">
        Para começarmos, escreva o seu e-mail
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input class="ui-input login-input" ref="email" type="email" name="email" maxlenght="50" autofocus
          v-model="form.email" :disabled="btnAvancar.disabled" required
          @keyup.enter.prevent="goToStep('name', form.email)" />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        {{ validateErrors }}
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('name', form.email)"
        :disabled="btnAvancar.disabled" v-html="btnAvancar.text"></button>
      <a class="ui-center" href="/login">
        <h4 class="ui-paragraph f-20">Já tem uma conta?</h4>
      </a>
    </div>
    <div class="bloco" id="user_detail2" v-if="activePhase == 'name'">
      <h1 class="ui-title f-32 cadastro_title">
        Para conseguirmos te indentificar
      </h1>
      <h4 class="ui-paragraph f-20 cadastro_frase" :class="fonte_invalida">
        Digite o seu nome completo
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input class="ui-input login-input" ref="name" type="text" name="nome" maxlenght="50" v-model="form.nome"
          required @keyup.enter.prevent="goToStep('cpf', form.nome)" />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Este campo é obrigatório
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('cpf', form.nome)">
        Continuar
      </button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
          cursor-pointer
        " @click="backToStep('email')">
        Voltar
      </h4>
    </div>

    <div class="bloco" id="user_detail14" v-if="activePhase == 'cpf'"
      @keyup.enter.prevent="goToStep('phone', form.cpf)">
      <h1 class="ui-title f-32 cadastro_title">
        Para conseguirmos te indentificar
      </h1>
      <h4 class="ui-paragraph f-20 cadastro_frase" :class="fonte_invalida">
        Digite o seu CPF
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <the-mask class="ui-input login-input" type="text" ref="cpf" name="cpf" v-model="form.cpf"
          :disabled="btnAvancar.disabled" required :masked="true" :mask="['###.###.###-##']"></the-mask>
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        {{ validateErrors }}
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('phone', form.cpf)"
        :disabled="btnAvancar.disabled" v-html="btnAvancar.text"></button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
          cursor-pointer
        " @click="backToStep('name')">
        Voltar
      </h4>
    </div>

    <div class="bloco" id="user_detail3" v-if="activePhase == 'phone'"
      @keyup.enter.prevent="goToStep('password', form.tel)">
      <h1 class="ui-title f-32 cadastro_title">
        Para conseguirmos te contatar
      </h1>
      <h4 class="ui-paragraph f-20 cadastro_frase" :class="fonte_invalida">
        Qual o seu telefone?
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <the-mask class="ui-input login-input" type="text" id="phone" ref="phone" name="tel" v-model="form.tel"
          :masked="true" :mask="['(##) #####-####', '(##) ####-####']" required />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Insira um telefone válido
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('password', form.tel)">
        Continuar
      </button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        " @click="backToStep('cpf')">
        Voltar
      </h4>
    </div>

    <!-- <div
      class="bloco"
      id="user_detail4"
      v-if="activePhase == 'birthday'"
      @keyup.enter.prevent="goToStep('cep', form.aniver)"
    >
      <h1 class="ui-title f-32 cadastro_title">Sua data de nascimento</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Digite sua data de nascimento, lembrando que deve ser maior de idade
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <the-mask
          class="ui-input login-input"
          type="text"
          ref="birthday"
          v-model="form.aniver"
          :disabled="btnAvancar.disabled"
          :masked="true"
          :mask="['##/##/####']"
          placeholder="__/__/____"
          @keyup.enter.prevent="goToStep('cep', form.aniver)"
          required
        ></the-mask>
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        {{ validateErrors }}
      </p>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('cep', form.aniver)"
        :disabled="btnAvancar.disabled"
        v-html="btnAvancar.text"
      ></button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('phone')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div
      class="bloco"
      id="user_detail5"
      v-if="activePhase == 'cep'"
      @keyup.enter.prevent="goToStep('street', form.cep)"
    >
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Qual é o seu CEP? (opcional)
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <the-mask
          class="ui-input login-input"
          type="text"
          id="cep"
          ref="cep"
          name="cep"
          v-model="form.cep"
          :disabled="btnAvancar.disabled"
          :masked="true"
          :mask="['#####-###']"
          required
        />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">Insira um CEP válido</p>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('street', form.cep)"
        :disabled="btnAvancar.disabled"
        v-html="btnAvancar.text"
      ></button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('phone')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div
      class="bloco"
      id="user_detail6"
      v-if="activePhase == 'street'"
      @keyup.enter.prevent="goToStep('district', form.rua)"
    >
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Qual é sua rua? (opcional)
      </h4>
      <div class="bloco-input" id="user_detail7" :class="bloco_invalido">
        <input
          class="ui-input login-input"
          type="text"
          id="rua"
          maxlenght="50"
          ref="street"
          name="rua"
          v-model="form.rua"
          required
        />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Este campo é obrigatório
      </p>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('district', form.rua)"
      >
        Continuar
      </button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('cep')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div
      class="bloco"
      id="user_detail8"
      v-if="activePhase == 'district'"
      @keyup.enter.prevent="goToStep('number', form.bairro)"
    >
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Qual é o seu bairro? (opcional)
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input
          class="ui-input login-input"
          type="text"
          ref="district"
          maxlenght="50"
          id="bairro"
          name="bairro"
          v-model="form.bairro"
          required
        />
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Este campo é obrigatório
      </p>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('number', form.bairro)"
      >
        Continuar
      </button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('street')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div
      class="bloco"
      id="user_detail9"
      v-if="activePhase == 'number'"
      @keyup.enter.prevent="goToStep('complement', form.numero)"
    >
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Qual é o número da sua residência? (opcional)
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input
          class="ui-input login-input"
          type="text"
          ref="number"
          maxlenght="10"
          name="numero"
          v-model="form.numero"
        />
      </div>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('complement', form.numero)"
      >
        Continuar
      </button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('district')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div
      class="bloco"
      id="user_detail10"
      v-if="activePhase == 'complement'"
      @keyup.enter.prevent="goToStep('state', form.complemento)"
    >
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4
        class="ui-paragraph f-20 cadastro_frase nascimento"
        :class="fonte_invalida"
      >
        Possui algum complemento? (opcional)
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input
          class="ui-input login-input"
          type="text"
          ref="complement"
          maxlenght="150"
          name="complemento"
          v-model="form.complemento"
          required
        />
      </div>
      <button
        class="ui-button-yellow login-button"
        type="button"
        @click.prevent="goToStep('state', form.complemento)"
      >
        Continuar
      </button>
      <h4
        class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        "
        @click="backToStep('number')"
      >
        Voltar
      </h4>
    </div> -->

    <!-- <div class="bloco" id="user_detail11" v-if="activePhase == 'state'"
      @keyup.enter.prevent="goToStep('city', model_state)">
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4 class="ui-paragraph f-20 cadastro_frase nascimento" :class="fonte_invalida">
        Por favor, selecione o seu estado
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <select class="ui-input login-input" ref="state" required v-model="model_state" id="state" name="state"
          @keyup.enter.prevent="disableEnter">
          <option v-for="(option, index) in select_state" :key="index" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Este campo é obrigatório
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('city', model_state)">
        Continuar
      </button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        " @click="backToStep('phone')">
        Voltar
      </h4>
    </div> -->

    <!-- <div class="bloco" id="user_detail12" v-if="activePhase == 'city'"
      @keyup.enter.prevent="goToStep('password', model_city)">
      <h1 class="ui-title f-32 cadastro_title">Seu endereço:</h1>
      <h4 class="ui-paragraph f-20 cadastro_frase nascimento" :class="fonte_invalida">
        Por favor, selecione sua cidade.
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <select class="ui-input login-input" ref="city" required v-model="model_city" id="city" name="city">
          <option v-for="(option, index) in select_cities" :key="index" :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Este campo é obrigatório
      </p>
      <button class="ui-button-yellow login-button" type="button" @click.prevent="goToStep('password', model_city)">
        Continuar
      </button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        " @click="backToStep('state')">
        Voltar
      </h4>
    </div> -->

    <div class="bloco" id="user_detail13" v-if="activePhase == 'password'" @keyup.enter.prevent="submitForm()">
      <h1 class="ui-title f-32 cadastro_title">E por último!</h1>
      <h4 class="ui-paragraph f-20 cadastro_frase nascimento" :class="fonte_invalida">
        Coloque uma senha segura da qual vai se lembrar.
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input class="ui-input login-input password" id="passwordCadastro" ref="password" type="password" name="senha"
          v-model="form.senha" minlength="8" required />
        <i class="fa fa-eye-slash icon f-20" aria-hidden="true" id="eyesCadastro" onclick="mostrarSenha()"></i>
      </div>
      <h4 class="ui-paragraph f-20 cadastro_frase nascimento" :class="fonte_invalida">
        Agora, confirme a sua senha.
      </h4>
      <div class="bloco-input" :class="bloco_invalido">
        <input class="ui-input login-input password" type="password" id="passwordCadastro2" name="confirmaSenha"
          v-model="form.confirmaSenha" minlength="8" required />
        <i class="fa fa-eye-slash icon f-20" aria-hidden="true" id="eyesCadastro2" onclick="mostrarSenha2()"></i>
      </div>
      <p v-if="texto_invalido" class="ui-invalid-font">
        Você precisa proteger sua conta
      </p>
      <button class="ui-button-yellow login-button" type="submit" @click.prevent="submitForm()"
        :disabled="btnSubmit.disabled" v-html="btnSubmit.text"></button>
      <h4 class="
          ui-paragraph
          f-20
          voltar
          align-items-center
          d-flex
          justify-content-center
        " @click="backToStep('phone')">
        Voltar
      </h4>
    </div>
    <div v-if="!(JSON.stringify(errors) == '{}')" class="bloco-erro alert" id="blocoErro">
      <i class="fa fa-times" aria-hidden="true" data-dismiss="alert" style="cursor: pointer"></i>
      <ul>
        <li class="f-20" v-for="(item, index) in errors" :key="index" @click="backToStep(index)"
          style="cursor: pointer">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import brazil from "/public/cities/cidades.json";
import axios from "axios";
import Vuetify from "vuetify";

export default {
  vuetify: new Vuetify(),
  props: ["city", "state"],
  components: {},
  data() {
    return {
      activePhase: "email",
      isActive: false,
      btnAvancar: {
        text: "<i>Continuar</i>",
        disabled: false,
      },
      form: {
        nome: "",
        cpf: "",
        email: "",
        tel: "",
        aniver: "",
        senha: "",
        // cep: "",
        // rua: "",
        // bairro: "",
        // numero: "",
        // complemento: "",
        confirmaSenha: "",
      },
      select_cities: [],
      select_state: [],
      model_state: "",
      model_city: "",
      bloco_invalido: "",
      fonte_invalida: "",
      texto_invalido: false,
      btnSubmit: {
        text: "<i>Cadastrar-se</i>",
        disabled: false,
      },
      errors: {},
      validateErrors: "",
    };
  },

  created() {
    if (this.city) {
      this.model_city = this.city;
    }
    if (this.state) {
      this.model_state = this.state;
    }
    for (var city of brazil.estados) {
      this.select_state.push({
        value: city.sigla,
        label: city.nome,
      });
    }
  },
  watch: {
    "form.cep"() {
      this.ViaCep();
    },

    model_state() {
      this.select_cities = brazil.estados.filter((estado) => {
        if (estado.sigla == this.model_state) {
          return estado.cidades;
        }
      });
      if (this.select_cities[0]) {
        for (var city of this.select_cities[0].cidades) {
          this.select_cities.push({
            value: city,
            label: city,
          });
        }
      }
    },
  },
  methods: {
    goToStep: async function (step, model) {
      if (model == "" || model == null || model == 0) {
        if (this.activePhase == "number") {
          this.bloco_invalido = "";
          this.fonte_invalida = "";
          this.texto_invalido = false;
          this.activePhase = step;
          setTimeout(() => {
            this.$refs.complement.focus();
          }, 200);
        } else if (this.activePhase == "complement") {
          this.bloco_invalido = "";
          this.fonte_invalida = "";
          this.texto_invalido = false;
          this.activePhase = step;
          setTimeout(() => {
            this.$refs.state.focus();
          }, 200);
        } else if (this.activePhase == "cep") {
          this.bloco_invalido = "";
          this.fonte_invalida = "";
          this.texto_invalido = false;
          this.activePhase = step;
          setTimeout(() => {
            this.$refs.street.focus();
          }, 200);
        } else if (this.activePhase == "street") {
          this.bloco_invalido = "";
          this.fonte_invalida = "";
          this.texto_invalido = false;
          this.activePhase = step;
          setTimeout(() => {
            this.$refs.district.focus();
          }, 200);
        } else if (this.activePhase == "district") {
          this.bloco_invalido = "";
          this.fonte_invalida = "";
          this.texto_invalido = false;
          this.activePhase = step;
          setTimeout(() => {
            this.$refs.number.focus();
          }, 200);
        } else {
          this.bloco_invalido = "ui-invalid-bloco";
          this.fonte_invalida = "ui-invalid-font";
          this.texto_invalido = true;
        }
      } else {
        switch (this.activePhase) {
          case "cpf":
            var val = await this.validate(model, 0);
            let val1Req = () => {
              return val;
            };
            if (val1Req() == "") {
              this.bloco_invalido = "";
              this.fonte_invalida = "";
              this.validateErrors = "";
              this.texto_invalido = false;
              this.activePhase = step;
              setTimeout(() => {
                this.$refs.phone.$el.focus();
              }, 200);
              if (step == "password") {
                this.isActive = true;
              }
            } else {
              this.bloco_invalido = "ui-invalid-bloco";
              this.fonte_invalida = "ui-invalid-font";
              this.texto_invalido = true;
              this.validateErrors = val1Req();
            }
            break;

          case "email":
            var val = await this.validate(model, 1);
            let val2Req = () => {
              return val;
            };
            if (val2Req() == "") {
              this.bloco_invalido = "";
              this.fonte_invalida = "";
              this.validateErrors = "";
              this.texto_invalido = false;
              this.activePhase = step;
              setTimeout(() => {
                this.$refs.name.focus();
              }, 200);
              if (step == "password") {
                this.isActive = true;
              }
            } else {
              this.bloco_invalido = "ui-invalid-bloco";
              this.fonte_invalida = "ui-invalid-font";
              this.texto_invalido = true;
              this.validateErrors = val2Req();
            }
            break;

          // case "birthday":
          //   var val = await this.validate(model, 2);
          //   let val3Req = () => {
          //     return val;
          //   };
          //   if (val3Req() == "") {
          //     this.bloco_invalido = "";
          //     this.fonte_invalida = "";
          //     this.validateErrors = "";
          //     this.texto_invalido = false;
          //     this.activePhase = step;
          //     setTimeout(() => {
          //       this.$refs.cep.$el.focus();
          //     }, 200);
          //     if (step == "password") {
          //       this.isActive = true;
          //     }
          //   } else {
          //     this.bloco_invalido = "ui-invalid-bloco";
          //     this.fonte_invalida = "ui-invalid-font";
          //     this.texto_invalido = true;
          //     this.validateErrors = val3Req();
          //   }
          //   break;

          case "phone":
            if (this.form.tel.length == 15 || this.form.tel.length == 14) {
              this.bloco_invalido = "";
              this.fonte_invalida = "";
              this.texto_invalido = false;
              this.activePhase = step;
              setTimeout(() => {
                this.$refs.cep.$el.focus();
              }, 200);
              if (step == "password") {
                this.isActive = true;
              }
            } else {
              this.bloco_invalido = "ui-invalid-bloco";
              this.fonte_invalida = "ui-invalid-font";
              this.texto_invalido = true;
            }
            break;

          case "name":
            this.bloco_invalido = "";
            this.fonte_invalida = "";
            this.texto_invalido = false;
            this.activePhase = step;
            setTimeout(() => {
              this.$refs.cpf.$el.focus();
            }, 200);
            if (step == "password") {
              this.isActive = true;
            }
            break;

          case "number":
            this.bloco_invalido = "";
            this.fonte_invalida = "";
            this.texto_invalido = false;
            this.activePhase = step;
            setTimeout(() => {
              this.$refs.complement.focus();
            }, 200);
            if (step == "password") {
              this.isActive = true;
            }
            break;

          case "street":
            this.bloco_invalido = "";
            this.fonte_invalida = "";
            this.texto_invalido = false;
            this.activePhase = step;
            setTimeout(() => {
              this.$refs.district.focus();
            }, 200);
            if (step == "password") {
              this.isActive = true;
            }
            break;

          // case "state":
          //   this.bloco_invalido = "";
          //   this.fonte_invalida = "";
          //   this.texto_invalido = false;
          //   this.activePhase = step;
          //   setTimeout(() => {
          //     this.$refs.city.focus();
          //   }, 200);
          //   if (step == "password") {
          //     this.isActive = true;
          //   }
          //   break;

          // case "city":
          //   this.bloco_invalido = "";
          //   this.fonte_invalida = "";
          //   this.texto_invalido = false;
          //   this.activePhase = step;
          //   setTimeout(() => {
          //     this.$refs.password.focus();
          //   }, 200);
          //   if (step == "password") {
          //     this.isActive = true;
          //   }
          //   break;

          case "district":
            this.bloco_invalido = "";
            this.fonte_invalida = "";
            this.texto_invalido = false;
            this.activePhase = step;
            setTimeout(() => {
              this.$refs.number.focus();
            }, 200);
            if (step == "password") {
              this.isActive = true;
            }
            break;

          case "cep":
            if (this.form.cep.length == 9) {
              this.bloco_invalido = "";
              this.fonte_invalida = "";
              this.texto_invalido = false;
              this.activePhase = step;
              setTimeout(() => {
                this.$refs.street.focus();
              }, 200);
            } else {
              this.bloco_invalido = "ui-invalid-bloco";
              this.fonte_invalida = "ui-invalid-font";
              this.texto_invalido = true;
            }
            break;

          default:
            this.bloco_invalido = "";
            this.fonte_invalida = "";
            this.texto_invalido = false;
            this.activePhase = step;
            if (step == "password") {
              this.isActive = true;
            }
            break;
        }
      }
    },
    backToStep: function (step) {
      console.log(this.form.aniver);
      console.log(this.form.cpf);
      console.log(this.form.tel);
      this.bloco_invalido = "";
      this.fonte_invalida = "";
      this.texto_invalido = false;
      this.activePhase = step;
      if (this.errors[step]) {
        delete this.errors[step];
      }
    },
    ViaCep: function () {
      if (this.form.cep) {
        if (this.form.cep.length == 9) {
          this.btnAvancar = {
            text: "<div class='loader'></div>",
            disabled: true,
          };
          axios.get("viacep/" + this.form.cep).then((response) => {
            if (response.data.erro) {
              this.$swal("Oops!", "CEP Inválido!", "error");
              this.cep = "";
            } else {
              this.model_state = response.data.uf;
              this.model_city = response.data.localidade;
              this.form.rua = response.data.logradouro;
              this.form.bairro = response.data.bairro;
            }
            this.btnAvancar = {
              text: "<i>Continuar</i>",
              disabled: false,
            };
            setTimeout(() => {
              this.$refs.cep.$el.focus();
            }, 200);
          });
        }
      }
    },
    validate: async function (valor, tipo) {
      this.btnAvancar = {
        text: "<div class='loader'></div>",
        disabled: true,
      };
      var req = await axios
        .post("/api/validate", { valor: valor, tipo: tipo })
        .then((res) => {
          return res.data;
        });
      let returnReq = () => {
        let a = req;
        return a;
      };
      this.btnAvancar = {
        text: "<i>Continuar</i>",
        disabled: false,
      };
      return returnReq();
    },
    submitForm: async function () {
      var dataForm = {
        name: this.form.nome,
        email: this.form.email,
        cpf: this.form.cpf,
        phone: this.form.tel,
        // birthday: this.form.aniver,
        // cep: this.form.cep,
        // state: this.model_state,
        // city: this.model_city,
        // district: this.form.bairro,
        // street: this.form.rua,
        // number: this.form.numero,
        // complement: this.form.complemento,
        password: this.form.senha,
        password_confirm: this.form.confirmaSenha,
      };
      this.btnSubmit = {
        text: "<div class='loader'></div>",
        disabled: true,
      };
      await axios
        .post("/register", dataForm)
        .then((res) => {
          console.log(res)
          if (res.data.errors) {
            var errors = res.data.errors;
            var errorsKeys = Object.keys(errors);
            for (let i = 0; i < errorsKeys.length; i++) {
              const key = errorsKeys[i];
              if (key == "password_confirm") {
                this.errors["password"] = errors[key][0];
              } else {
                this.errors[key] = errors[key][0];
              }
            }
          } else {
            this.$swal({
              title: res.data,
              type: "success",
              preConfirm: () => {
                window.location.href = "/contrato";
              },
            }).then((r) => {
              if (r.dismiss) {
                window.location.href = "/contrato";
              }
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.$swal({
            title: e.response.data,
            text: "Contate o nosso suporte ou tente novamente mais tarde",
            type: "error",
          });
        });
      this.btnSubmit = {
        text: "<i>Cadastrar-se</i>",
        disabled: false,
      };
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },
};
</script>
